import { useEffect, useState } from 'react';
import { Package } from 'lucide-react';
import { customerApi, fmtDate } from '../../lib/api';

const pillFor = (s) =>
  ({
    pending: 'pill pill-partial',
    confirmed: 'pill pill-paid',
    rejected: 'pill pill-unpaid',
    cancelled: 'pill pill-draft',
  }[s] || 'pill pill-draft');

const statusLabel = (s) =>
  ({ pending: 'Awaiting quote', confirmed: 'Invoiced', rejected: 'Declined', cancelled: 'Cancelled' }[s] || s);

export default function CustomerOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    customerApi.get('/customer/orders').then((r) => setOrders(r.data));
  }, []);

  return (
    <div className="fade-in space-y-4" data-testid="cust-orders-page">
      <div>
        <h1 className="text-3xl font-semibold">My Quote Requests</h1>
        <p className="text-sm text-[#6b7280] mt-1">Track requests you've submitted. Once invoiced, view in Invoices.</p>
      </div>

      {orders.length === 0 ? (
        <div className="card p-10 text-center text-sm text-[#6b7280]">
          <Package size={32} className="mx-auto mb-2 text-[#d4d4d4]" />
          You haven't submitted any quote requests yet.
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => {
            const totalUnits = (o.items || []).reduce((s, i) => s + (i.qty || 0), 0);
            return (
              <div key={o.order_id} className="card p-5" data-testid={`cust-order-${o.order_id}`}>
                <div className="flex items-start justify-between flex-wrap gap-3 mb-3">
                  <div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="mono font-semibold">{o.order_number}</span>
                      <span className={pillFor(o.status)}>{statusLabel(o.status)}</span>
                    </div>
                    <div className="text-xs text-[#6b7280] mt-0.5">{fmtDate(o.created_at)}</div>
                  </div>
                  <div className="text-right">
                    <div className="mono font-semibold">{totalUnits} units</div>
                    {o.status === 'confirmed' && o.invoice_id && (
                      <div className="text-xs text-green-700">Invoice sent ✓</div>
                    )}
                    {o.status === 'rejected' && o.rejection_reason && (
                      <div className="text-xs text-[#d92027] italic max-w-xs">{o.rejection_reason}</div>
                    )}
                  </div>
                </div>
                <div className="pt-3 border-t border-[#f3f3f3] space-y-1 text-sm">
                  {(o.items || []).map((it, i) => (
                    <div key={i} className="flex justify-between">
                      <span>{it.name}</span>
                      <span className="mono">× {it.qty}</span>
                    </div>
                  ))}
                </div>
                {o.notes && (
                  <div className="mt-3 pt-3 border-t border-[#f3f3f3] text-xs text-[#6b7280] italic">
                    "{o.notes}"
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
